import { createSlice } from '@reduxjs/toolkit';
import InitialContext from 'state/static-data/InitialContext';
import { ApplicationState } from 'state/store/configureStore';
import { ASINType, Offer, OffersState, VisitType } from 'state/types';

const FEATURE_NAME = `all-offers`;
const initialState: OffersState = {
  offers: InitialContext.getOffers()
};

const slice = createSlice({
  name: FEATURE_NAME,
  initialState: initialState,
  reducers: {
  },
});

export const selectOffersState = (state: ApplicationState): OffersState => state.offersState;
export const selectOfferByAsin = (offers: Offer[], asin: ASINType): Offer | undefined => offers.find(offer => offer.asin === asin);


export default slice.reducer;